import { Field } from 'react-final-form';
import { FormControl } from '../../../input/FormControl';
import { Input } from '../../../input/Input';
import { LinkFieldProps } from '../types';

export const LinkField = ({
    name,
    required,
    disabled,
    validate,
    label,
    placeholder,
    onFieldBlur,
}: LinkFieldProps) => (
    <Field
        name={name}
        validate={validate}
        render={({ input, meta }) => (
            <FormControl
                required={required}
                disabled={disabled}
                pt={1}
                pb={1}
                label={label}
                error={meta.touched ? Boolean(meta.error) : undefined}
                message={meta.touched ? meta.error : undefined}
            >
                <Input
                    {...input}
                    type="text"
                    autoComplete="off"
                    placeholder={placeholder}
                    onBlur={(event) => {
                        onFieldBlur(name, event.target.value);
                        input.onBlur(event);
                    }}
                />
            </FormControl>
        )}
    />
);
